<div class="flex flex-col">
    <!-- Header -->
    <div class="flex flex-0 sticky top-0 z-50 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
        <div class="text-lg font-medium">{{ 'presenceConcepts.editConcept' | transloco }}</div>
        <button mat-icon-button (click)="closeDialog()" [tabIndex]="-1">
            <mat-icon class="text-on-primary" [svgIcon]="'mat_outline:close'"></mat-icon>
        </button>
    </div>

    <div class="flex flex-col p-8">
        <div class="flex w-full gap-4">
            <mat-form-field class="w-2/5">
                <mat-label>{{ 'presenceConcepts.logicalConcept' | transloco }}</mat-label>
                <input matInput [(ngModel)]="logicalConcept" disabled>
            </mat-form-field>
            <mat-form-field class="w-1/5">
                <mat-label>{{ 'presenceConcepts.type' | transloco }}</mat-label>
                <input matInput [(ngModel)]="type" disabled>
            </mat-form-field>
            <div class="flex items-center w-1/5">
                <mat-form-field class="w-full">
                    <mat-label>{{ 'presenceConcepts.from' | transloco }}</mat-label>
                    <input matInput [(ngModel)]="fromDate" [matDatepicker]="fromPicker" readonly (click)="openDatepickerOnClick(fromPicker)">
                    <mat-datepicker-toggle matIconSuffix [for]="fromPicker"></mat-datepicker-toggle>
                    <mat-datepicker #fromPicker></mat-datepicker>
                </mat-form-field>
                <button mat-icon-button (click)="fromDate.set(undefined)">
                    <mat-icon [svgIcon]="'mat_outline:close'"></mat-icon>
                </button>
            </div>
            <div class="flex items-center w-1/5">
                <mat-form-field class="w-full">
                    <mat-label>{{ 'presenceConcepts.to' | transloco }}</mat-label>
                    <input matInput [(ngModel)]="toDate" [matDatepicker]="toPicker" readonly (click)="openDatepickerOnClick(toPicker)">
                    <mat-datepicker-toggle matIconSuffix [for]="toPicker"></mat-datepicker-toggle>
                    <mat-datepicker #toPicker></mat-datepicker>
                </mat-form-field>
                <button mat-icon-button (click)="toDate.set(undefined)">
                    <mat-icon [svgIcon]="'mat_outline:close'"></mat-icon>
                </button>
            </div>
        </div>

        <div class="flex w-full gap-4">
            <mat-form-field class="w-1/4">
                <mat-label>{{ 'presenceConcepts.workplace' | transloco }}</mat-label>
                <input matInput [(ngModel)]="workplaceCode" disabled>
            </mat-form-field>
        </div>

        <label>{{ 'presenceConcepts.dispatchToNet4' | transloco }}</label>
        <mat-radio-group class="p-4" [(ngModel)]="dispatchMode" color="primary">
            <mat-radio-button class="mx-2" value="DAILY">{{ 'presenceConcepts.DAILY' | transloco }}</mat-radio-button>
            <mat-radio-button class="mx-2" value="MONTHLY">{{ 'presenceConcepts.MONTHLY' | transloco }}</mat-radio-button>
            <mat-radio-button class="mx-2" value="NEVER">{{ 'presenceConcepts.NEVER' | transloco }}</mat-radio-button>
        </mat-radio-group>

        <div class="flex w-full gap-4">
            <mat-form-field class="w-2/3">
                <mat-label>{{ 'presenceConcepts.concept' | transloco }}</mat-label>
                <input matInput [(ngModel)]="concept" [matAutocomplete]="conceptAC">
                <mat-autocomplete #conceptAC="matAutocomplete" [displayWith]="conceptACDisplay">
                    @for (option of conceptOptions(); track option.Codigo) {
                        <mat-option [value]="option">{{ option.Nombre }}</mat-option>
                    }
                </mat-autocomplete>
            </mat-form-field>
        </div>
        
        @if (data.concept.conceptType === "TIME") {
            <div class="flex w-full gap-4">
                <mat-form-field class="w-1/3">
                    <mat-label>{{ 'presenceConcepts.net4Format' | transloco }}</mat-label>
                    <mat-select [(ngModel)]="net4Format">
                        @for (option of net4FormatOptions(); track option.code) {
                            <mat-option [value]="option.code">
                                {{ option.value | localize }}
                            </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
                <mat-form-field class="w-1/5">
                    <mat-label>{{ 'presenceConcepts.roundInterval' | transloco }}</mat-label>
                    <input matInput type="number" [(ngModel)]="roundInterval">
                </mat-form-field>
                <mat-form-field class="w-1/5">
                    <mat-label>{{ 'presenceConcepts.roundPoint' | transloco }}</mat-label>
                    <input matInput type="number" [(ngModel)]="roundPoint">
                </mat-form-field>
            </div>
        }

        @if (!data.concept.logicalConcept.startsWith('{')) {
            <mat-form-field class="w-1/2">
                <mat-label>{{ 'presenceConcepts.net4Formula' | transloco }}</mat-label>
                <mat-select [(ngModel)]="formula">
                    <mat-option [value]="''">
                        {{ 'presenceConcepts.noFormula' | transloco }}
                    </mat-option>
                    @for (option of formulaOptions(); track option.code) {
                        <mat-option [value]="option.code">
                            {{ option.value | localize }}
                        </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        }

        <mat-slide-toggle class="pb-4" [(ngModel)]="mustBeInBillingLine">{{ 'presenceConcepts.mustBeInBillingLine' | transloco }}</mat-slide-toggle>

        <mat-form-field class="w-2/3">
            <mat-label>{{ 'presenceConcepts.exclusions' | transloco }}</mat-label>
            <mat-chip-grid #exclusionsGrid>
                @for (value of excludeNet4ConceptId(); track value; let index = $index) {
                    <mat-chip-row (removed)="removeExclusion(index)">
                        {{ value }}
                        <button matChipRemove>
                            <mat-icon class="icon-size-5" [svgIcon]="'heroicons_solid:minus-circle'"></mat-icon>
                        </button>
                    </mat-chip-row>
                }
                <input matInput [matChipInputFor]="exclusionsGrid" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                    [matChipInputAddOnBlur]="true" (matChipInputTokenEnd)="addExclusion($event)">
            </mat-chip-grid>
        </mat-form-field>

        @if (customizing()) {
            <div class="flex gap-4 py-2">
                <p class="text-lg font-medium">{{ 'presenceConcepts.customize' | transloco }}</p>
                <mat-slide-toggle color="primary" [(ngModel)]="newConcept">{{ 'presenceConcepts.customizeNewConcept' | transloco }}</mat-slide-toggle>
            </div>
            <mat-divider class="py-2"></mat-divider>
            <div class="flex w-full gap-4">
                <mat-form-field class="w-1/2">
                    <mat-label>{{ 'presenceConcepts.contractType' | transloco }}</mat-label>
                    <mat-select [(ngModel)]="contractType">
                        <mat-option [value]="''">
                            {{ 'presenceConcepts.allContractType' | transloco }}
                        </mat-option>
                        <mat-option [value]="'CSE'">
                            {{ 'presenceConcepts.CSE' | transloco }}
                        </mat-option>
                        <mat-option [value]="'CPD'">
                            {{ 'presenceConcepts.CPD' | transloco }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="flex w-full">
                <mat-form-field class="w-1/2">
                    <mat-label>{{ 'presenceConcepts.company' | transloco }}</mat-label>
                    <input matInput [(ngModel)]="empresa" [matAutocomplete]="companyAC">
                    <mat-autocomplete #companyAC="matAutocomplete" [displayWith]="companyACDisplay">
                        @for (option of filteredEmpresaOptions(); track option.code) {
                            <mat-option [value]="option">{{ option.value | localize }}</mat-option>
                        }
                    </mat-autocomplete>
                </mat-form-field>
            </div>
            <div class="flex w-full gap-4">
                <mat-form-field class="w-1/2">
                    <mat-label>{{ 'presenceConcepts.jobs' | transloco }}</mat-label>
                    <mat-select [(ngModel)]="jobSupervisor">
                        <mat-option [value]="''">
                            {{ 'presenceConcepts.allJobs' | transloco }}
                        </mat-option>
                        <mat-option [value]="'SUPERVISORY'">
                            {{ 'presenceConcepts.SUPERVISORY' | transloco }}
                        </mat-option>
                        <mat-option [value]="'NON_SUPERVISORY'">
                            {{ 'presenceConcepts.NON_SUPERVISORY' | transloco }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="flex w-full">
                <mat-form-field class="w-1/2">
                    <mat-label>{{ 'presenceConcepts.jobContractCode' | transloco }}</mat-label>
                    <input matInput [(ngModel)]="jobContractCode" type="number">
                </mat-form-field>
            </div>
            <div class="flex w-full">
                <worker-chiplist-ac class="w-1/2" [control]="control" [searchCtrl]="searchCtrl" [caption]="'presenceConcepts.workers' | transloco"
                [placeholder]="undefined | localize" [options]="options$"
                [readonly]="false" [required]="false" [id]="'trabajadorNet4Id'" [locator]="this.data.locator"></worker-chiplist-ac> 
            </div>
            <div class="flex w-full">
                <mat-form-field class="w-1/2">
                    <mat-label>{{ 'presenceConcepts.score' | transloco }}</mat-label>
                    <input matInput [(ngModel)]="score" disabled>
                </mat-form-field>
            </div>
        }
    </div>

    <div class="flex justify-end p-4 sticky bottom-0">
        @if (!customizing()) {
            <button class="mr-2" mat-raised-button color="accent" (click)="customizing.set(true)">
                {{ 'presenceConcepts.customize' | transloco }}
            </button>
        } @else {
            <button class="mr-2" mat-raised-button color="accent" (click)="cancelCustomizing()">
                {{ 'presenceConcepts.cancelCustomizing' | transloco }}
            </button>
        }
        <button class="mr-2" mat-raised-button color="warn" (click)="closeDialog()">
            {{ 'cancel' | transloco }}
        </button>
        <button class="mr-2" mat-raised-button color="primary" (click)="accept()">
            {{ 'accept' | transloco }}
        </button>
    </div>
</div>
    